import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'app/core/auth/services/auth.service';
import { DeviceInfo } from './device.interface';
import { IPaginationResult } from 'app/common/interfaces';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';

@Component({
  selector: 'app-linked-device',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIcon,
    MatDialogModule,
    FormatOtherDateHourPipe
  ],
  templateUrl: './linked-device.component.html',
})
export class LinkedDeviceComponent {

  filteredDevices: DeviceInfo[] = []
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<LinkedDeviceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit(): void {
    this.getListDevice()
  }

  trackByFn(index: number, item: any): any {
    return item.deviceIdentifier || index;
  }

  getListDevice(){
    this.authService.getListMobileIdentifier(this.data.user_login_id).subscribe({
      next: (res: DeviceInfo[]) => {
        this.filteredDevices = res;
      },
      error: (err) => {
        this.filteredDevices = []
        this.snackBar.open(err.error.message || "Error al limpiar identificador móvil del usuario","Cerrar",{ duration: 5000});
      }
    })
  }

  openDeleteDialog(device: DeviceInfo): void {
    this.dialog
      .open(this.deleteDialog, { data: device, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.closeMobileIdentifier(device));
  }

  closeMobileIdentifier(device: DeviceInfo){
    this.authService.clearMobileIdentifier(device.user_login_id, device.deviceIdentifier).subscribe({
      next: (res) => {
        this.getListDevice()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al limpiar identificador móvil del usuario","Cerrar",{ duration: 5000});
      }
    });
  }
}
